<app-confirmation-dialog [props]="confirmationDialogProps" id="file-upload-dialog">
  <div class="popup-upload-container" id="file-upload-container">
    <div class="content-container">
      @if (!initFront) {
        <div class="loading-container" id="file-upload-init-loading">
          <app-ellipsis-loading id="file-upload-ellipsis-loading"></app-ellipsis-loading>
          <span i18n="@@loadingInformation" id="file-upload-span-loading">Cargando información</span>
        </div>
      }
      <!-- <div *ngIf="!countryEnabled">
      <div class="container-fluid row d-flex justify-content-center py-1" style="margin:0; padding-top: 60px; padding-bottom: 20px; gap: 8px;">
        <button type="button" mat-raised-button style="width: 325px;"
        (click)="setActionCl('PERSON')" i18n="@@button_massive_load_related_ruts">Carga Masiva RUTS relacionados</button>

        <button type="button" mat-raised-button style="width: 325px;"
        (click)="setActionCl('COMPANY')" i18n="@@button_massive_load_partners">Carga Masiva Socios y sociedades</button>

        <button type="button" mat-raised-button *ngIf="!files.length" style="width: 325px;"
        (click)="cancel()" i18n="@@button_cancel">Cancelar</button>
      </div>
    </div> -->

    @if (!isBusy && initFront) {
      <div id="file-upload-form-content">
        <div class="row d-flex justify-content-center selects-container" id="file-upload-selects-wrapper">
          <mat-form-field appearance="outline" id="file-upload-field-followup">
            <mat-select
              id="file-upload-select-followup"
              [(ngModel)]="selectedFollowUpTime"
              [(value)]="selectedFollowUpTime"
              required
              >
              @for (time of followUpTimes; track time; let iFU = $index) {
                <mat-option [value]="time.value" id="file-upload-option-followup-{{iFU}}">
                  {{ time.label }}
                </mat-option>
              }
            </mat-select>
            <mat-label id="file-upload-label-followup">
              <mat-icon id="file-upload-icon-hand">hand</mat-icon>
              <strong i18n="@@Followed_time">Tiempo de seguimiento</strong>
            </mat-label>
          </mat-form-field>
          <app-wallet-select
            id="file-upload-select-wallet"
            class="wallet-selector"
            [(ngModel)]="selectedWallet"
            [enableAutoSelect]="true"
            [excludeAlert30Days]="true"
            data-testid="wallet-select"
            />
          </div>
          <ngx-file-drop
            dropZoneClassName="drop-zone-content"
            class="file-drop-container"
            [accept]="'.xls'"
            id="file-upload-drop-zone"
            dropZoneLabel="Arrastre aquí sus archivos"
            (onFileDrop)="dropped($event)"
            [multiple]="false"
            [accept]="acceptedFormats?.join(',')"
            >
            <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
              <div class="container-fluid ngx-file-content" id="file-upload-drop-content">
                <div class="row d-flex justify-content-center" id="file-upload-files-list">
                  @if (!files.length) {
                    <div class="col-auto text-center py-1" id="file-upload-msg-dragdrop">
                      <span i18n="@@message_drag_and_drop_file">
                    Arrastrar el archivo para realizar una carga masiva.
                  </span>
                    </div>
                  }
                  @for (item of rawFiles; track item; let i = $index) {
                    <div class="col-auto text-center py-1" id="file-upload-file-item-{{i}}">
                      <strong>{{ item.relativePath }}</strong>
                    </div>
                  }
                </div>
                @if (!isState(STATES.FILE_LOAD)) {
                  <div
                    class="row d-flex justify-content-center py-2"
                    id="file-upload-actions"
                    >
                    @if (!files.length) {
                      <button
                        id="file-upload-btn-select"
                        type="button"
                        mat-raised-button
                        (click)="openFileSelectorPoxy(openFileSelector)"
                        i18n="@@button_select"
                        >
                  Seleccionar
                </button>
                    }
                    <span style="padding-left: 10px"></span>
                    <button
                      id="file-upload-btn-template"
                      type="button"
                      mat-raised-button
                      (click)="handleDownloadTemplate()"
                      i18n="@@button_download_template_xlsx"
                      >
                  Descargar template xlsx
                </button>
                    <span style="padding-left: 10px"></span>
                    <button id="file-upload-btn-layout" type="button" mat-raised-button (click)="handleDownloadLayout()">
                      Layout<mat-icon>insert_drive_file</mat-icon>
                    </button>
                    <span style="padding-left: 10px"></span>
                    @if (files.length) {
                      <button
                        id="file-upload-btn-accept"
                        mat-button
                        (click)="commitFiles()"
                        mat-raised-button
                        i18n="@@button_accept"
                        >
                  Aceptar
                </button>
                    }
                    <span style="padding-left: 10px"></span>
                    @if (files.length) {
                      <button
                        id="file-upload-btn-cancel"
                        type="button"
                        mat-raised-button
                        (click)="cancel()"
                        i18n="@@button_cancel"
                        >
                  Cancelar
                </button>
                    }
                  </div>
                }
                <div class="row" id="file-upload-processing-wrapper">
                  <div class="col">
                    <div>
                      @if (isState(STATES.FILE_LOAD)) {
                        <app-ellipsis-loading id="file-upload-ellipsis-loading-uploading"></app-ellipsis-loading>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </ngx-file-drop>
        </div>
      }

      @if (isBusy && initFront) {
        <div class="processing-file" id="file-upload-msg-processing">
          <span i18n="@@message_file_processing">
          Un archivo esta siendo procesado. Puede revisar su status en el listado de
          <strong>archivos procesados</strong>
        </span>
        </div>
      }
    </div>
  </div>
</app-confirmation-dialog>
